/** 
 * Responsive breakpoints for v-responsive (vue-responsive)
 * @file
 */

import { mapState, mapActions } from 'vuex'

import { VUEX_GLOBAL_SET_MOBILE_STATE } from '@/store/constants/mobile'

const Responsive = {
	
	data: () => ({
		deviceSize: null,
		mobileView: null,

		responsiveMarks$$sila: {  //set a custom breakpoint with the name "sila"
			small: { 
				show: true, 
				min: -1, 
				max: 768 
			}, 
			medium: { 
				show: true, 
				min: 769, 
				max: 1024 
			},
			large: { 
				show: true, 
				min: 1025, 
				max: 1299 
			},
			xlarge: { 
				show: true, 
				min: 1300, 
				max: Infinity	 
			} 
		}
	}),

	computed:{
		...mapState({
			mobile: state => state.mobile.mobile,
		})
	},

	created() {
		this.init()
	},

	methods: {
		...mapActions({
			setMobileState: VUEX_GLOBAL_SET_MOBILE_STATE,
        }),

		init() {
			this.addResizeListener()
			this.initialScreenSize()
		},

		setMobile(width){
			if (width < this.responsiveMarks$$sila.large.min && this.mobile === false) {
				this.setMobileState(true) 
			} 
			if (width >= this.responsiveMarks$$sila.large.min && this.mobile === true ){
				this.setMobileState(false) 
			}
		},

		initialScreenSize(){
			let width = window.innerWidth
			this.setMobile(width)
		},

		handleResize(evt) {
			let width = evt.target.innerWidth
			this.setMobile(width)
		},

		setDeviceSize() {
			/*this.deviceSize = 'small'
			this.mobileView = true*/
		},

		addResizeListener() { window.addEventListener('resize', this.handleResize) },
		removeResizeListener() { window.removeEventListener('resize', this.handleResize) },
	}
}

export default Responsive
